// import { UserDataT } from "@/types/auth";
import { create } from "zustand";
import Axios from "../lib/Axios";

const useInterestListStore = create((set) => ({
  interestList: [],
  interestListSelectCompatiable: [],
  fetchInterest: async () => {
    try {
      const result = await Axios.post("/cms/cms-get/interest-names");
      const data = result?.data?.result?.results?.map((item) => {
        return { label: item.interestName, value: item.interestId, ...item };
      });
      set((state) => ({
        interestList: result?.data?.result?.results,
        interestListSelectCompatiable: data,
      }));
    } catch (error) {}
  },
}));

export default useInterestListStore;
